import actions from './actions-user.js'
import mutations from './mutations-user.js'
import getters from './getters-user.js'
import state from './state-user.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}